import { RouteLocationRaw } from 'vue-router'
import { EmployeeRouteNames, MembersRouteNames } from '@/router/routes-names'

export type Operator = {
    id: string,
    origin: string,
    name: string
}

export function isEmployee (operator: Operator): boolean {
    return operator.origin === 'employee'
}

export function isMember (operator: Operator): boolean {
    return operator.origin === 'member'
}

export function operatorLink (operator: Operator): RouteLocationRaw {
    switch (true) {
    case isEmployee(operator):
        return {
            name: EmployeeRouteNames.EDIT,
            params: { id: operator.id }
        }
    case isMember(operator):
        return {
            name: MembersRouteNames.SHOW,
            params: { memberId: operator.id }
        }
    }
    return { name: MembersRouteNames.LIST, query: { page: '1' } }
}
